import { useReports } from '@/api/hooks/useReports'
import React from 'react'
import Sidebar from '../Sidebar'
import { createReportDialog } from './report-wizard/CreateReport'
import Report from './Report'
import ReportsItems from './ReportsItem'
import styled from 'styled-components'

// const mockData = ["Парковки на завтра", "Брони на вчера", "Количество занятых мест"]
const mockData = [
  {
    name: 'Список броней на выбранный день',
    key: 'bookings-report'
  },
  {
    name: 'Нагрузка на рабочее место',
    key: 'place-report'
  }
  // {
  //     name: "Отчет по площадям",
  //     key: "square-report"
  // },
  // {
  //     name: "Список свободных мест на период",
  //     key: "empty"
  // }
]

const Reports = () => {
  const { reports } = useReports()

  return (
    <Sidebar style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Sidebar.Header title="reports" />
      <span  style={{ borderBottom: '1px solid #B1B5C3', marginTop: '20px' }}></span>
      <Sidebar.Content style={{ flex: 1, overflowY: 'auto' }}>
        {reports.map((item) => (
          <Report key={'report ' + item} report={item} />
        ))}
        {mockData.map((item) => (
          <ReportsItems key={'report ' + item} item={item} />
        ))}
      </Sidebar.Content>

      <StyledButton $fullWidth onClick={createReportDialog}>
        <span className="text">Новый отчет</span>
      </StyledButton>
    </Sidebar>
  )
}

const StyledButton = styled.div<{ $fullWidth?: boolean }>`
  background-color: #C12423;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 12.5px;
  padding-bottom: 12.5px; 
  border-radius: 8px;
  cursor: pointer;
  justify-content: center;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  &:hover {
    background-color: #b71c1c;
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    line-height: 120%;
  }
`;


export default Reports
